import { TableAction } from "../../../../../../components/ModularDataTable"
import { i18n } from "../../../../../../translate/i18n"



type ActionsFactoryParams = {
  navigate: (path: string) => void
  showDeleteModal: (title: string) => void
  setProductId: (id: number) => void
  isAdmin: boolean
  plugintype: 'varejo' | 'fashion'
}

export function createActions({
  navigate,
  showDeleteModal,
  setProductId,
  isAdmin,
  plugintype,
}: ActionsFactoryParams): TableAction[] {
  const editLabel = `${i18n.t(`general.edit`)} ${i18n.t(`smart_order.product`)}`

  const routeToEdit = plugintype === 'varejo' ? 'product_varejo' : 'product_fashion'

  const actions: TableAction[] = [
    {
      icon: 'fas fa-pen',
      label: editLabel,
      action: (item: any) => navigate(`/${routeToEdit}/editar/${item.id}`),
    },
  ]
  return actions
}
